import React, { useEffect, useRef, forwardRef } from "react";
import { useState } from "react";
import "./Grievance.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import axios from "axios";
import "rc-time-picker-date-fns/assets/index.css";
import { TimerComponent } from "./TimerComponent.js";

export default function VzyGrievance() {
  const [contentTypes, setContentTypes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [grievanceText, setGrievanceText] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState(null);
  const [checkEdit, setCheckEdit] = useState(false);

  const [grievances, setGrievances] = useState([]);
  const [isModalSubmitted, setIsModalSubmitted] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [startDate, setStartDate] = useState(new Date());

  const [statesData, setStatesData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  const [isSuccess, setIsSuccess] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [grievanceErrors, setGrievanceErrors] = useState({});
  const [touchedOverride, setTouchedOverride] = useState({
    state: false,
    city: false,
  });
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    state: "",
    city: "",
    contentType: "tv", // Default value as string
    contentName: "",
    seasonEpisode: "",
    episodeTitle: "",
    viewedOn: "",
    createdBy: "",
  });

  // Set the base URL globally
  const apiBaseURL =
    process.env.REACT_APP_API_URL || `${window.location.origin}`;

  useEffect(() => {
    const fetchContentTypes = async () => {
      try {
        const response = await axios.get(
          `${apiBaseURL}/api/WatchoGrievance/GetContentTypes`,
        );
        if (response.data.resultStatus === "Success") {
          setContentTypes(response.data.result || []);
        }
      } catch (error) {
        console.error("Error fetching content types:", error);
      }
    };
    fetchContentTypes();
  }, []);

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <input
      type="text"
      value={value}
      onClick={onClick}
      readOnly
      className="form-input"
      ref={ref}
    />
  ));

  useEffect(() => {
    validate(formData, touched);
  }, [touched, formData, grievances]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Only allow numbers in the "phone" field
    if (name === "phone" && !/^\d*$/.test(value)) {
      return; // Prevent updating if non-numeric
    }

    if (name === "contentName") {
      const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
      return;
    }
    if (name === "seasonEpisode") {
      const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
      return;
    }
    if (name === "episodeTitle") {
      const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
      return;
    }
    if (name === "fullName") {
      const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
      return;
    }

    if (name === "email") {
      const cleanValue = value.replace(/[^a-zA-Z0-9@._+-]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanValue }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (data = formData, touchedData = touchedOverride) => {
    const newErrors = {};

    if (touchedData.fullName) {
      if (!data.fullName.trim()) {
        newErrors.fullName = "Full name is required";
      } else if (data.fullName.trim().length < 3) {
        newErrors.fullName = "Full name must be at least 3 characters";
      } else if (data.fullName.trim().length > 40) {
        newErrors.fullName = "Full name cannot exceed 40 characters";
      }
    }

    if (touchedData.phone) {
      if (!data.phone.trim()) {
        newErrors.phone = "Phone is required";
      } else if (!/^[6-9]\d{9}$/.test(data.phone.trim())) {
        newErrors.phone = "Enter valid 10-digit mobile number start with 6-9";
      }
    }

    if (touchedData.email) {
      if (!data.email.trim()) {
        newErrors.email = "Email is required";
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          data.email.trim(),
        )
      ) {
        newErrors.email = "Enter valid email address";
      }
    }

    if (touchedData.state) {
      if (!data.state) {
        newErrors.state = "State is required";
      }
    }

    if (touchedData.city && !data.city) {
      newErrors.city = "City is required";
    }

    if (touchedData.contentName) {
      if (!data.contentName.trim()) {
        newErrors.contentName = "Content name is required";
      } else if (data.contentName.trim().length < 3) {
        newErrors.contentName = "Content name must be at least 3 characters";
      } else if (data.contentName.trim().length > 100) {
        newErrors.contentName = "Content name cannot exceed 100 characters";
      }
    }

    if (data.contentType === "tv") {
      if (touchedData.seasonEpisode) {
        if (!data.seasonEpisode.trim()) {
          newErrors.seasonEpisode = "Season & Episode required";
        } else if (data.seasonEpisode.trim().length < 3) {
          newErrors.seasonEpisode =
            "Season & Episode must be at least 3 characters";
        } else if (data.seasonEpisode.trim().length > 30) {
          newErrors.seasonEpisode =
            "Season & Episode cannot exceed 30 characters";
        }
      }

      if (touchedData.episodeTitle) {
        if (!data.episodeTitle.trim()) {
          newErrors.episodeTitle = "Episode Title required";
        } else if (data.episodeTitle.trim().length < 3) {
          newErrors.episodeTitle =
            "Episode Title must be at least 3 characters";
        } else if (data.episodeTitle.trim().length > 80) {
          newErrors.episodeTitle = "Episode Title cannot exceed 80 characters";
        }
      }
    }

    if (touchedData.viewedOn && !data.viewedOn) {
      newErrors.viewedOn = "Viewed on is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      showErrorToast();
    }

    return Object.keys(newErrors).length === 0;
  };
  const handleBlur = (e) => {
    const { name } = e.target;
    const newTouched = { ...touched, [name]: true };
    setTouched(newTouched);
    validate(formData, newTouched); // pass updated touched
  };

  // Returns current date and time in DD-MM-YYYY HH:mm:ss format

  const today = new Date();

  function formatDate() {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    const day = pad(now.getDate());
    const month = now.toLocaleString("en-US", { month: "short" }); // → "Feb"
    const year = now.getFullYear();
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched to show validation errors
    const allTouched = {
      fullName: true,
      email: true,
      phone: true,
      state: true,
      city: true,
      contentName: true,
      viewedOn: true,
      ...(formData.contentType === "tv" && {
        seasonEpisode: true,
        episodeTitle: true,
      }),
    };
    setTouched(allTouched);

    const fullForm = {
      ...formData,
      viewedOn: startDate ? startDate.toISOString().split("T")[0] : "",
    };

    const isValid = validate(fullForm, allTouched);
    if (!isValid) {
      showErrorToast(); // 👈 show toast on error
      return;
    }

    const completeData = {
      Platform: "vzy",
      Name: formData.fullName,
      Email: formData.email,
      MobileNo: formData.phone,
      StateId: formData.state,
      CityId: formData.city,
      ContentType: formData.contentType === "movie" ? "1" : "2",
      ContentName: formData.contentName,
      SeasonEpisode: formData.seasonEpisode || "",
      ContentTitle: formData.episodeTitle || "",
      ContentViewedOn: startDate.toISOString().split("T")[0] + "T00:00:00",
      CreatedBy: "123456",
      GrievanceDescriptions: grievances.map((g) => ({
        Description: g.grievanceText,
        StartTime: `2025-07-22T${g.startTime}`,
        EndTime: `2025-07-22T${g.endTime}`,
      })),
    };

    try {
      const response = await axios.post(
        `${apiBaseURL}/api/WatchoGrievance/SubmitGrievanceDetails`,
        completeData,
      );

      // Check the resultStatus from API response
      if (
        response.data.resultStatus === "Success" &&
        response.data.resultCode === 200
      ) {
        setIsSuccess(true);
        setModalMessage("Grievance report submitted");
        handleResetForm();
      } else {
        setIsSuccess(false);
        setModalMessage(
          response.data.resultMessage || "Failed to submit grievance.",
        );
      }
    } catch (error) {
      console.error("Error:", error);
      setIsSuccess(false);
      setModalMessage("An error occurred while submitting the grievance.");
    } finally {
      setIsModalSubmitted(true);
    }
  };

  const goToHome = () => {
    setIsModalSubmitted(false);
  };

  const handleResetForm = () => {
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      state: "",
      city: "",
      contentType: "tv",
      contentName: "",
      seasonEpisode: "",
      episodeTitle: "",
      viewedOn: "",
    });
    setTouched({});
    setErrors({});
    setStartDate(new Date()); // Reset date
    setGrievances([]); // Clear grievance list
    setCityData([]); // Clear city dropdown
    setStartTime(); // Reset time inputs
    setEndTime();
    setGrievanceText(""); // Reset grievance textarea
    setEditIndex(null); // Clear edit index
    setIsModalOpen(false); // Close modal if open
  };

  const resetGrievanceFields = () => {
    setStartTime();
    setEndTime();
    setGrievanceText("");
    setEditIndex(null);
    setGrievanceErrors({});
    setIsModalOpen(false);
  };

  const canSubmit = () => {
    const requiredFields = [
      formData.fullName,
      formData.email,
      formData.phone,
      formData.state,
      formData.city,
      formData.contentName,
      startDate,
    ];

    if (formData.contentType === "tv") {
      requiredFields.push(formData.seasonEpisode, formData.episodeTitle);
    }

    // All fields must be non-empty, have no errors, and at least one grievance is required
    return (
      requiredFields.every((val) => val && val.toString().trim() !== "") &&
      grievances.length > 0 &&
      Object.keys(errors).length === 0
    );
  };

  const formatTimeObject = (timeObj) => {
    if (!timeObj || typeof timeObj !== "object") return "00:00:00";
    const { hour = "00", minute = "00", second = "00" } = timeObj;
    return `${hour.padStart(2, "0")}:${minute.padStart(
      2,
      "0",
    )}:${second.padStart(2, "0")}`;
  };

  const handleSaveGrievance = () => {
    const newErrors = {};

    if (!startTime || startTime === "00:00:00") {
      newErrors.startTime = "Start time is required";
    }

    if (!endTime || endTime === "00:00:00") {
      newErrors.endTime = "End time is required";
    }

    if (!grievanceText.trim()) {
      newErrors.grievanceText = "Please enter your grievance";
    }

    setGrievanceErrors(newErrors);

    // If errors exist, stop execution
    if (Object.keys(newErrors).length > 0) return;

    // If no errors, save grievance
    const newGrievance = {
      startTime: formatTimeObject(startTime),
      endTime: formatTimeObject(endTime),
      grievanceText,
    };
    if (editIndex !== null) {
      const updated = [...grievances];
      updated[editIndex] = newGrievance;
      setGrievances(updated);
      setEditIndex(null);
    } else {
      setGrievances((prev) => [...prev, newGrievance]);
    }

    setStartTime(null);
    setEndTime(null);
    setGrievanceText("");
    setIsModalOpen(false);
  };

  const handleDeleteGrievance = (index) => {
    const updated = grievances.filter((_, i) => i !== index);
    setGrievances(updated);
  };

  // Converts "10:30:00" → { hour: "10", minute: "30", second: "00" }
  const parseTimeString = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string")
      return { hour: "00", minute: "00", second: "00" };
    const [h, m, s] = timeStr.split(":");
    return {
      hour: h?.padStart(2, "0") || "00",
      minute: m?.padStart(2, "0") || "00",
      second: s?.padStart(2, "0") || "00",
    };
  };

  const handleEditGrievance = (index) => {
    const g = grievances[index];
    const parsedStart = parseTimeString(g.startTime);
    const parsedEnd = parseTimeString(g.endTime);

    setStartTime(parsedStart);
    setEndTime(parsedEnd);
    setGrievanceText(g.grievanceText);
    setEditIndex(index); // track this in state
    setIsModalOpen(true); // open the modal
    setCheckEdit(true); // set checkEdit to true
  };

  useEffect(() => {
    const fetchStateData = async () => {
      try {
        const postData = { Qry: "State" };

        const response = await axios.post(
          `${apiBaseURL}/api/WatchoGrievance/GetState_Cities`,
          postData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        // Save data to state
        setStatesData(response.data.result || []);
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchStateData();
  }, []);

  const fetchCityByStateId = async (stateId) => {
    try {
      const postData = { StateId: stateId, Qry: "City" };
      const response = await axios.post(
        `${apiBaseURL}/api/WatchoGrievance/GetState_Cities`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setCityData(response.data.result || []);
    } catch (error) {
      console.error("City fetch error:", error);
    }
  };

  function showErrorToast() {
    const toast = document.getElementById("errorToast");
    toast.style.display = "flex"; // show

    setTimeout(() => {
      toast.style.display = "none"; // auto-hide after 3s
    }, 3000);
  }

  return (
    <>
      <div id="Grievence">
        <form onSubmit={handleSubmit}>
          <div className="container">
            <div className="wid85">
              <div className="headerMobileView">
                <span className="leftArrow">
                  <img src="../images/Grievence/leftArrowIcon.png" alt="icon" />
                </span>
                <h2>
                  Required Information
                  <span className="reset" onClick={handleResetForm}>
                    Reset
                  </span>
                </h2>
              </div>

              {/* Personal Info */}
              <div className="form-grid">
                <div className="form-group">
                  <input
                    type="text"
                    name="fullName"
                    maxLength={40}
                    minLength={3}
                    autoComplete="off"
                    className={`form-input ${
                      errors.fullName ? "inpu-Invalid" : ""
                    }`}
                    value={formData.fullName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder=" "
                  />
                  {errors.fullName && (
                    <span className="grievanc-Error">{errors.fullName}</span>
                  )}
                  <label className="form-label">Full Name<span className="text-danger">*</span></label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    autoComplete="off"
                    className={`form-input ${
                      errors.email ? "inpu-Invalid" : ""
                    }`}
                    name="email"
                    maxLength={30}
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder=" "
                  />
                  {errors.email && (
                    <span className="grievanc-Error">{errors.email}</span>
                  )}
                  <label className="form-label">Email address<span className="text-danger">*</span></label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    autoComplete="off"
                    className={`form-input ${
                      errors.phone ? "inpu-Invalid" : ""
                    }`}
                    name="phone"
                    maxLength={10}
                    value={formData.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder=" "
                  />
                  {errors.phone && (
                    <span className="grievanc-Error">{errors.phone}</span>
                  )}
                  <label className="form-label">Phone Number<span className="text-danger">*</span></label>
                </div>

                <div className="form-group">
                  <CustomDropdown
                    label="State*"
                    options={statesData}
                    selected={statesData.find((s) => s.id === formData.state)}
                    onChange={handleChange}
                    className={`${errors.state ? "inpu-Invalid" : ""}`}
                    onBlur={() => {
                      const newTouched = { ...touched, state: true };
                      setTouched(newTouched);
                      validate(formData, newTouched);
                    }}
                    onSelect={(item) => {
                      const updatedForm = {
                        ...formData,
                        state: item.id,
                        city: "",
                      };
                      setFormData(updatedForm); // only update form
                      const updatedTouched = { ...touched, state: true };
                      setTouched(updatedTouched);

                      fetchCityByStateId(item.id);
                    }}
                    error={errors.state}
                    hasError={errors.state && touched.state}
                  />

                  {errors.state && (
                    <span className="grievanc-Error customError">
                      {errors.state}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <CustomDropdown
                    label="City*"
                    options={cityData}
                    selected={cityData.find((c) => c.id === formData.city)}
                    onChange={handleChange}
                    onBlur={() => {
                      const updatedTouched = { ...touched, city: true };
                      setTouched(updatedTouched);
                      validate(formData, updatedTouched);
                    }}
                    onSelect={(item) => {
                      const updatedForm = { ...formData, city: item.id };
                      setFormData(updatedForm); // only update form

                      const updatedTouched = { ...touched, city: true };
                      setTouched(updatedTouched);

                      validate(updatedForm, updatedTouched);
                    }}
                    error={errors.city}
                    hasError={errors.city && touched.city}
                    disabled={!formData.state}
                  />

                  {errors.city && (
                    <span className="grievanc-Error customError">
                      {errors.city}
                    </span>
                  )}
                </div>
              </div>

              <hr className="hrStyle" />
              {/* Content Type */}

              <h6 style={{ marginBottom: "0.5rem" }} className="tocnt">
                Type of Content
              </h6>
              {/* Radio Buttons */}
              <div className="radio-toggle-group" role="radiogroup">
                {contentTypes.map((type) => {
                  const normalizedValue = type.name.toLowerCase().includes("tv")
                    ? "tv"
                    : type.name.toLowerCase().includes("movie")
                      ? "movie"
                      : "others"; // 👈 handle fallback case

                  const isSelected = formData.contentType === normalizedValue;

                  return (
                    <div
                      key={type.id}
                      className={`radio-wrapper ${isSelected ? "active" : ""}`}
                      tabIndex={0}
                      role="radio"
                      aria-checked={isSelected}
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          contentType: normalizedValue,
                        }))
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setFormData((prev) => ({
                            ...prev,
                            contentType: normalizedValue,
                          }));
                        }
                      }}
                    >
                      {/* Hidden input if needed for form data */}
                      <input
                        type="radio"
                        name="contentType"
                        value={normalizedValue}
                        checked={isSelected}
                        style={{ display: "none" }}
                        readOnly
                      />
                      <span className="custom-radio"></span>
                      <span>{type.name}</span>
                    </div>
                  );
                })}
              </div>

              {/* Content Details */}
              <div className="form-grid2">
                <div className="form-group">
                  <input
                    type="text"
                    autoComplete="off"
                    name="contentName"
                    maxLength={100}
                    minLength={3}
                    className={`form-input ${
                      errors.contentName ? "inpu-Invalid" : ""
                    }`}
                    value={formData.contentName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder=" "
                  />
                  {errors.contentName && (
                    <span className="grievanc-Error">{errors.contentName}</span>
                  )}
                  <label className="form-label">Content Name<span className="text-danger">*</span></label>
                </div>

                {/* These 2 only for TV */}
                {formData.contentType === "tv" && (
                  <>
                    <div className="form-group">
                      <input
                        type="text"
                        autoComplete="off"
                        name="seasonEpisode"
                        maxLength={30}
                        minLength={3}
                        className={`form-input ${
                          errors.seasonEpisode ? "inpu-Invalid" : ""
                        }`}
                        value={formData.seasonEpisode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder=" "
                      />
                      {errors.seasonEpisode && (
                        <span className="grievanc-Error">
                          {errors.seasonEpisode}
                        </span>
                      )}

                      <label className="form-label">Season & Episode<span className="text-danger">*</span></label>
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        autoComplete="off"
                        name="episodeTitle"
                        maxLength={80}
                        minLength={3}
                        className={`form-input ${
                          errors.episodeTitle ? "inpu-Invalid" : ""
                        }`}
                        value={formData.episodeTitle}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder=" "
                      />
                      {errors.episodeTitle && (
                        <span className="grievanc-Error">
                          {errors.episodeTitle}
                        </span>
                      )}
                      <label className="form-label">Episode Title<span className="text-danger">*</span></label>
                    </div>
                  </>
                )}

                {/* Content Viewed On - always visible */}
                <div className="form-group date-wrapper">
                  <DatePicker
                    selected={startDate}
                    name="viewedOn"
                    onChange={(date) => setStartDate(date)}
                    calendarClassName="custom-calendar"
                    dateFormat="dd-MM-yyyy"
                    customInput={<CustomInput />}
                    maxDate={today}
                    minDate={
                      new Date(
                        today.getFullYear(),
                        today.getMonth() - 1,
                        today.getDate() + 1,
                      )
                    } // min date = 1 month ago
                    className={`form-input  ${
                      errors.viewedOn ? "inpu-Invalid" : ""
                    }`}
                  />

                  <img
                    src="../images/Grievence/calendar-icon.png"
                    alt="Calendar"
                    className="calendar-icon"
                  />

                  {errors.viewedOn && (
                    <span className="grievanc-Error">{errors.viewedOn}</span>
                  )}
                  <label
                    className="form-label fontLabelMobile"
                    style={{ top: "-0.6rem" }}
                  >
                    Content Viewed On
                  </label>
                </div>
              </div>

              <hr className="hrStyle" />

              {/* Grievance Description */}

              <div className="descriptionInputGroupStyle">
                <div>
                  <h6>Describe your grievance *</h6>
                </div>
                {grievances.length > 0 && (
                  <div id="addGrievanceButton">
                    <button
                      type="button"
                      className="buttonLink"
                      onClick={() => setIsModalOpen(true)}
                    >
                      <span className="plus-icon">+</span> Add New Time Stamp
                    </button>
                  </div>
                )}
              </div>

              {grievances.length === 0 && !isModalOpen && (
                <div className="form-group" id="descriptionInputGroup">
                  <button
                    type="button"
                    className="add-description-btn"
                    id="descriptionButton"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <span className="plus-icon">+</span> Add Description
                  </button>
                </div>
              )}

              {/* Display All Saved Grievances */}
              {grievances.map((item, index) => (
                <div key={index} className="grievance-box" id="grievanceBox">
                  <div className="grievance-box-header">
                    <strong>
                      Time Stamp : {item.startTime} – {item.endTime}
                    </strong>
                    <div className="grievance-actions">
                      <button
                        className="icon-btn"
                        type="button"
                        onClick={() => handleDeleteGrievance(index)}
                      >
                        <img
                          src="../images/Grievence/delete.png"
                          alt="Delete"
                        />
                      </button>
                      <button
                        className="icon-btn"
                        type="button"
                        onClick={() => handleEditGrievance(index)}
                      >
                        <img src="../images/Grievence/edit.png" alt="Edit" />
                      </button>
                    </div>
                  </div>
                  <p>{item.grievanceText}</p>
                </div>
              ))}

              {isModalOpen && (
                <div className="modal-overlay mobileView">
                  <div className="modal-content">
                    <h5>
                      Add your Grievance{" "}
                      <span
                        className="mobileClose"
                        onClick={() => resetGrievanceFields()}
                      >
                        <img src="../images/Grievence/_close.png" alt="close" />
                      </span>
                    </h5>
                    <div className="mobileViewSetting">
                      <strong style={{ marginBottom: "0px" }}>
                        Time Stamp
                      </strong>
                      <div className="modal-grid">
                        <div className="form-group time-wrapper">
                          <TimerComponent
                            value={startTime}
                            label="Start Time"
                            onChange={(val) => setStartTime(val)}
                            className={
                              grievanceErrors.startTime ? "inpu-Invalid" : ""
                            }
                          />
                          {grievanceErrors.startTime && (
                            <span className="grievanc-Error styleError">
                              {grievanceErrors.startTime}
                            </span>
                          )}
                        </div>
                        <div className="form-group time-wrapper">
                          <TimerComponent
                            label="End Time"
                            minTime={startTime}
                            endTime={endTime}
                            checkEdit={checkEdit}
                            onChange={(val) => {
                              setEndTime(val);
                            }}
                            className={
                              grievanceErrors.endTime ? "inpu-Invalid" : ""
                            }
                          />
                          {grievanceErrors.endTime && (
                            <span className="grievanc-Error styleError">
                              {grievanceErrors.endTime}
                            </span>
                          )}
                        </div>
                      </div>
                      <strong>How it affects you</strong>
                      <div className="form-group">
                        <textarea
                          className={`form-input ${
                            grievanceErrors.grievanceText ? "inpu-Invalid" : " "
                          }`}
                          placeholder=" "
                          rows={7}
                          value={grievanceText}
                          onChange={(e) => setGrievanceText(e.target.value)}
                        />
                        <label className="form-label">
                          Enter your grievance
                        </label>
                        {grievanceErrors.grievanceText && (
                          <span className="grievanc-Error styleError">
                            {grievanceErrors.grievanceText}
                          </span>
                        )}
                      </div>
                      <div className="modal-actions">
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={() => resetGrievanceFields()}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="submit-btn-footer"
                          onClick={handleSaveGrievance}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {isModalSubmitted && (
                <div className="modal-overlay modal-overlayForMobile">
                  <div className="modal-content" id="Submitted-Data">
                    {isSuccess ? (
                      <div className="tick-glow">
                        <svg viewBox="0 0 24 24">
                          <path d="M20.285 6.709l-11.025 11.025-5.646-5.646 1.414-1.414 4.232 4.232 9.611-9.611z" />
                        </svg>
                      </div>
                    ) : (
                      <div className="error-glow">
                        {/* Use a cross or error SVG here */}
                        <svg viewBox="0 0 24 24">
                          <path d="M18.364 5.636l-1.414-1.414L12 9.172 7.05 4.222 5.636 5.636 10.586 10.586 5.636 15.536l1.414 1.414L12 12.828l4.95 4.95 1.414-1.414-4.95-4.95z" />
                        </svg>
                      </div>
                    )}
                    <p className={isSuccess ? "headText" : "errorHeadText"}>
                      {modalMessage}
                    </p>
                    <hr className="hrStyle" />
                    {isSuccess && (
                      <div className="submitData">
                        <span>Submitted on</span>
                        <strong id="submittedDateTime">{formatDate()}</strong>
                      </div>
                    )}
                    <button className="goToHome" onClick={goToHome}>
                      Go to Home
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* footer start */}

          {/* tost  for mobile*/}
          <div id="errorToast" className="tost-error">
            <span className="toast-icon">
              <img src="../images/Grievence/errorMsg.png" alt="error" />
            </span>
            <span className="toast-text">Missing Required Fields</span>
          </div>
          {/* tost */}

          <div className="form-footer">
            <div className="container-fix">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleResetForm}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="submit-btn-footer"
                disabled={!canSubmit()}
              >
                Submit
              </button>
            </div>
          </div>
          {/* footer end */}
        </form>
      </div>

      {/* main div end */}

      {/* Preview Section (Initially Hidden) */}
    </>
  );
}

const CustomDropdown = ({
  options = [],
  selected,
  onSelect,
  label,
  disabled = false,
  onBlur, // ✅ support onBlur
  error, // ✅ support error display
  touched, // ✅ check if user interacted
  hasError, // ✅ receive it
}) => {
  const [open, setOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  // Filter options based on search
  const filteredOptions = search
    ? options.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase()),
      )
    : options;

  const toggleDropdown = () => {
    if (!disabled) setOpen((prev) => !prev);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
      setFocusedIndex(-1);
      setSearch("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setOpen((prev) => !prev);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setOpen(true);
      setFocusedIndex((prev) => (prev + 1) % filteredOptions.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setOpen(true);
      setFocusedIndex(
        (prev) => (prev - 1 + filteredOptions.length) % filteredOptions.length,
      );
    } else if (e.key === "Escape") {
      setOpen(false);
      setFocusedIndex(-1);
      setSearch("");
    }
  };

  const handleOptionKeyDown = (e, item, index) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(item);
      setOpen(false);
      setFocusedIndex(-1);
      setSearch("");
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setFocusedIndex((index + 1) % filteredOptions.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setFocusedIndex(
        (index - 1 + filteredOptions.length) % filteredOptions.length,
      );
    }
  };

  // Focus search input when dropdown opens
  const searchInputRef = useRef(null);
  useEffect(() => {
    if (open && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [open]);

  const isRequired = label.endsWith("*");
  const labelText = isRequired ? label.slice(0, -1) : label;

  return (
    <div
      className={`custom-dropdown ${disabled ? "disabled" : ""} ${
        open || selected ? "focused" : ""
      }`}
      ref={dropdownRef}
    >
      {!open || disabled ? (
        <div
          className={`dropdown-selected form-input ${hasError ? "inpu-Invalid" : ""}`}
          tabIndex={disabled ? -1 : 0}
          aria-haspopup="listbox"
          aria-expanded={open}
          onKeyDown={handleKeyDown}
          role="button"
          onClick={toggleDropdown}
          aria-disabled={disabled}
          onBlur={onBlur} // ✅ forward onBlur
        >
          <span title={selected?.name}>
            {selected
              ? selected.name.length > 20
                ? selected.name.slice(0, 20) + "…"
                : selected.name
              : ""}
          </span>
          <label className="dropdown-label">
            {labelText}
            {isRequired && <span className="text-danger">*</span>}
          </label>
          <span className="arrow">
            <img src="/images/Grievence/arrowIcon.png" />
          </span>
        </div>
      ) : (
        <>
          <input
            ref={searchInputRef}
            type="text"
            className="form-input"
            placeholder={`Search ${label.replace(/\*$/, "")}`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "ArrowDown" && filteredOptions.length > 0) {
                setFocusedIndex(0);
              }
            }}
            disabled={disabled}
            autoFocus
          />
          <label className="dropdown-label">
            {labelText}
            {isRequired && <span className="text-danger">*</span>}
          </label>
        </>
      )}
      {open && !disabled && (
        <ul className="dropdown-options">
          {filteredOptions.length === 0 && (
            <li className="dropdown-option disabled">No options found</li>
          )}
          {filteredOptions.map((item, index) => (
            <li
              key={item.id}
              className={`dropdown-option ${
                selected?.id === item.id ? "selected" : ""
              } ${index === focusedIndex ? "focused" : ""}`}
              role="option"
              tabIndex={-1}
              onClick={() => {
                onSelect(item);
                setOpen(false);
                setSearch("");
              }}
              onKeyDown={(e) => handleOptionKeyDown(e, item, index)}
            >
              {selected?.id === item.id && (
                <span className="tick">
                  <img
                    src="/images/Grievence/tick.png"
                    alt="tick"
                    width="13px"
                    height="9px"
                  />
                </span>
              )}
              {item.name.length > 20
                ? item.name.slice(0, 20) + "..."
                : item.name}
              {/* Truncate to 15 chars */}
            </li>
          ))}
        </ul>
      )}
      {touched && error && <div className="dropdown-error">{error}</div>}
    </div>
  );
};
